export class User {
  constructor(
    public id: number = -1,
    public name: string = '{name}',
    public email: string = '{email}',
    public default_budget_id: number = -1
  ) {}
}
